<mat-nav-list>
	<a mat-list-item routerLink="/dashboard" routerLinkActive="active">
		<mat-icon>dashboard</mat-icon>
		<span class="nav-title" i18n="@@titleDashboard">Dashboard</span>
	</a>
	<a mat-list-item
		routerLink="/chargers"
		[class.active]="router.url === '/chargers' || router.url.startsWith('/charger')"
	>
		<mat-icon>bolt</mat-icon>
		<span class="nav-title" i18n="@@titleChargers">Chargers</span>
	</a>
	<a mat-list-item routerLink="/groups" routerLinkActive="active">
		<mat-icon>layers</mat-icon>
		<span class="nav-title" i18n="@@titleGroups">Groups</span>
	</a>
	<a mat-list-item routerLink="/history" routerLinkActive="active">
		<mat-icon>history</mat-icon>
		<span class="nav-title" i18n="@@titleHistory">History</span>
	</a>
</mat-nav-list>

<span class="app-version"><span i18n="@@Version">version</span> {{ version }} ({{ commit }})</span>
